import cx from 'classnames';
import PropTypes from 'prop-types';

import createFieldClassNameByParticipantOrder from '@app/libs/participantFields/createFieldClassNameByParticipantOrder';

import TextIcon from '../TextIcon';

import './TextFieldIcon.scss';

const propTypes = {
  order: PropTypes.number,
};

const defaultProps = {
  order: 1,
};

function TextFieldIcon({ order }) {
  const textFieldIconClassByOrder = createFieldClassNameByParticipantOrder('TextFieldIcon', order);
  const className = cx('TextFieldIcon', textFieldIconClassByOrder);

  return (
    <div className={className}>
      <TextIcon />
    </div>
  );
}

TextFieldIcon.propTypes = propTypes;
TextFieldIcon.defaultProps = defaultProps;

export default TextFieldIcon;
